import GetUrls from 'ts/enums/Url'
import { Tax } from 'ts/types'
import useModalStore from 'store/modal'
import { CheckBox, Input } from 'components/ui'
import useModalForm from 'hooks/useModalForm'

const TaxAddPage = () => {
  const Url = GetUrls();
  const params = useModalStore((state) => state.params) as Tax
  const { ModalForm, form } = useModalForm()
  const { setValue, register } = form

  if (params) {
    setValue('taxTypeId', params.taxTypeId)
  }

  return (
    <ModalForm 
      config={{ url: Url.postTax, method: params ? 'PUT' : 'POST' }}
      title={`${params ? 'Edit ' : 'Create ' }Tax Type`}
      description='Create or edit a Tax Type'
    >
      {params ? (
        <Input defaultValue={params.taxTypeId} label="ID" disabled />
      ) : null}
      <CheckBox
        defaultChecked={params?.flActive || false}
        label="Active"
        {...register('flActive')}
      />
      <Input
        defaultValue={params?.name || ''}
        label="Tax Name"
        {...register('name', { required: true })}
      />
      <Input
        defaultValue={params?.taxRate || 0}
        type="number"
        label="Tax Rate"
        min={0}
        max={100}
        step={0.01}
        {...register('taxRate', { required: true, min: 0, max: 100 })}
      />

    </ModalForm>
  )
}

export default TaxAddPage
